const employmentStatuses = [
  {
    name: "Employed",
    value: "EMPLOYED",
  },
  {
    name: "Self-employed",
    value: "SELF_EMPLOYED",
  },
  {
    name: "Internship",
    value: "INTERNSHIP",
  },
  {
    name: "Scholarship",
    value: "SCHOLARSHIP",
  },
];

export default employmentStatuses;
